'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = squasher;

var _zip = require('lodash/zip');

var _zip2 = _interopRequireDefault(_zip);

var _last = require('lodash/last');

var _last2 = _interopRequireDefault(_last);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Merge two two-dimensional arrays.
 * @protected
 * @memberOf SquashedSubscription
 * @instance
 * @param {String[][]} source Source data for applying.
 * @param {String[][]} source Data with difference for applying.
 * @return {String[][]} Resulted applyied data.
 */
function mergeArrays(source, diff) {
    return (0, _zip2.default)(source, diff).map(function (recordValues) {
        return _zip2.default.apply(undefined, _toConsumableArray(recordValues)).map(function (fieldValues) {
            return (0, _last2.default)(fieldValues.filter(function (value) {
                return !!value;
            }));
        });
    });
}

function squasher() {
    var topicState = void 0;
    return {
        /**
         * Squash passed data with previous.
         * @protected
         * @memberOf squasher
         * @instance
         * @param {Object} data Parsed diffusion record.
         * @returns {String[][]} Squashed data.
         */
        squash: function squash(data) {
            topicState = !topicState ? data : mergeArrays(topicState, data);
            return topicState;
        },
        getState: function getState() {
            return topicState;
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/rp-diffusion-connector/lib/utils/squasher.js
// module id = 1930
// module chunks = 1